import React from "react";
import { CalendarDays, History, ChevronRight, Info } from "lucide-react";

const VacationDetailsScreen: React.FC = () => {
    return (
        <div className="max-w-md mx-auto p-4 bg-gray-50 min-h-screen">
            {/* Header */}
            <div className="flex items-center justify-center mb-4 relative">
                <div className="absolute top-0 left-0 w-full h-10 bg-gradient-to-b from-green-400 to-transparent"></div>
                <div className="flex items-center space-x-2 bg-white shadow-md px-4 py-2 rounded-lg">
                    <CalendarDays className="text-green-500 w-6 h-6" />
                    <span className="text-gray-800 font-medium">January 20, 2025</span>
                    <span className="text-gray-600">·</span>
                    <span className="text-green-500 font-medium">160 Hours</span>
                </div>
            </div>

            {/* Scheduled Time Off Section */}
            <section className="mb-6">
                <h2 className="text-lg font-semibold text-gray-700">Scheduled Time Off</h2>
                <p className="mt-2 text-gray-500">You have no upcoming time off.</p>
            </section>

            {/* History Section */}
            <section className="mb-6">
                <h2 className="text-lg font-semibold text-gray-700">History</h2>
                <div className="mt-4 space-y-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <History className="text-green-500 w-6 h-6" />
                            <span className="text-gray-700">July 12-13</span>
                        </div>
                        <span className="text-gray-700 font-medium">24 hours</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <History className="text-green-500 w-6 h-6" />
                            <span className="text-gray-700">June 26-27</span>
                        </div>
                        <span className="text-gray-700 font-medium">24 hours</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <History className="text-green-500 w-6 h-6" />
                            <span className="text-gray-700">June 10-11</span>
                        </div>
                        <span className="text-gray-700 font-medium">16 hours</span>
                    </div>
                </div>
                <div className="mt-4 flex justify-end">
                    <button className="flex items-center text-blue-500 hover:text-blue-600 focus:outline-none">
                        <span>See more Vacation history</span>
                        <ChevronRight className="w-5 h-5 ml-1" />
                    </button>
                </div>
            </section>

            {/* Vacation Policy Details Section */}
            <section className="p-4 bg-white rounded-lg shadow">
                <h2 className="text-lg font-semibold text-green-500 flex items-center">
                    <Info className="w-5 h-5 mr-2" />
                    Your Vacation Policy Details
                </h2>
                <p className="mt-2 text-gray-600 text-sm leading-relaxed">
                    You accrue <strong>6.67 hours</strong> twice a month on the 1 and 15. You will stop accruing time
                    after you hit a balance of <strong>160 hours</strong>. There is no limit to the number of hours you
                    can carry over.
                </p>
            </section>
        </div>
    );
};

export default VacationDetailsScreen;
